// Copyright (c) 2019 Deere & Company

import { errorAlertBar } from './error-alert-bar';

const errorTypes = {
    401: 'ERROR_SESSION',
    502: 'SERVER_TOOK_TOO_LONG_TO_REPLY',
    600: 'WARRANTY_APPLICATION_ERROR_CONTACT_ADMINISTRATOR',
};

const NETWORK_ERROR_MESSAGE = 'UNABLE_TO_CONTACT_THE_SERVER';

const hasStatus = response => response && typeof response.status === 'number';

const normalizeResponse = response => {
    if ( hasStatus( response ) ) {
        return response;
    }

    if ( response && hasStatus( response.response ) ) {
        return response.response;
    }

    return { status: 500, payload: response };
};

const getText = response => ( { message: errorTypes[response.status], isTranslated: true } );

const getAuthorizationError = async response => {

    try {

        const payload = await response.json();

        return payload && payload.messages && payload.messages.length ?
            payload : getText( response );

    } catch ( error ) {

        return getText( response );

    }

};

const getJson = async response => {
    if ( response && typeof response.json === 'function' ) {
        return response.json();
    }

    if ( response && response.payload ) {
        const payload = response.payload;

        if ( typeof payload === 'string' ) {
            return { message: NETWORK_ERROR_MESSAGE, isTranslated: true };
        }

        if ( payload instanceof Error ) {
            return { message: NETWORK_ERROR_MESSAGE, isTranslated: true };
        }

        return payload;
    }

    return response || { message: NETWORK_ERROR_MESSAGE, isTranslated: true };
};

export const handleError = async response => {

    const normalizedResponse = normalizeResponse( response );

    const errorType = errorTypes[normalizedResponse.status];

    const reply = normalizedResponse.status === 401 ?
        await getAuthorizationError( normalizedResponse ) : errorType ?
        await getText( normalizedResponse ) :
        await getJson( normalizedResponse );

    if ( normalizedResponse.status === 500 && reply && reply.statusCode === 600 ) {

        const replyCustom = { ...reply };
        if ( replyCustom.messages && replyCustom.messages[0] ) {
            replyCustom.messages[0].message = errorTypes[reply.statusCode];
        }
        errorAlertBar( replyCustom );

    } else {

        errorAlertBar( reply );

    }

    return Promise.reject( reply );

};
